import React, { useState } from 'react';
import './NotificationItem.css';
import { useNavigate } from 'react-router-dom';

const NotificationItem = ({
  id,
  title,
  message,
  dateTime,
  isRead = false,
  redirectionRequired = false,
  selected = false,
  onToggleSelect,
  onMarkedRead,
  onAskDelete,
  isDeletingExternal = false,
  onOpenAction,
}) => {
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  const handleMarkRead = async () => {
    if (pending || isDeletingExternal) return;
    if (!id) { console.warn('NotificationItem: id is undefined'); return; }
    setPending(true);
    try {
      onMarkedRead?.(id);
      if (typeof onOpenAction === 'function') {
        onOpenAction();
      } else if (redirectionRequired) {
        setTimeout(() => {
          navigate('/groups/group-details/97');
        }, 500);
      }
    } finally {
      setPending(false);
    }
  };

  const handleToggleSelect = (e) => {
    e.stopPropagation();
    onToggleSelect?.(id);
  };

  const askDelete = (e) => {
    e.stopPropagation();
    onAskDelete?.(id);
  };

  return (
    <div
      className={`notification-item ${isRead ? 'is-read' : 'is-unread'} ${isDeletingExternal ? 'fade-out' : ''}`}
      onClick={handleMarkRead}
      role="button"
      tabIndex={0}
      aria-busy={pending || isDeletingExternal}
      onKeyDown={(e) => { if (e.key === 'Enter') handleMarkRead(); }}
    >
      {/* Icono izquierdo: togglear selección */}
      <div className="notification-icon" onClick={handleToggleSelect} title={selected ? 'Selected' : 'Select'}>
        <div className={`icon-circle ${selected ? 'selected' : (isRead ? 'green' : 'red')}`}>
          {selected ? (
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
              <path d="M20.285 6.709a1 1 0 0 1 0 1.414l-9.192 9.192a1 1 0 0 1-1.414 0L3.715 11.55a1 1 0 1 1 1.414-1.414l5.04 5.04 8.485-8.467a1 1 0 0 1 1.631 0z" fill="currentColor"/>
            </svg>
          ) : (
            <svg className="email-icon-svg" viewBox="0 0 50 51" aria-hidden="true">
              <path d="M34.0234 16.6719H15.9766C15.1791 16.6727 14.4145 16.9899 13.8507 17.5538C13.2868 18.1177 12.9696 18.8822 12.9688 19.6797V32.5703C12.9696 33.3678 13.2868 34.1323 13.8507 34.6962C14.4145 35.2601 15.1791 35.5773 15.9766 35.5781H34.0234C34.8209 35.5773 35.5855 35.2601 36.1493 34.6962C36.7132 34.1323 37.0304 33.3678 37.0312 32.5703V19.6797C37.0304 18.8822 36.7132 18.1177 36.1493 17.5538C35.5855 16.9899 34.8209 16.6727 34.0234 16.6719ZM33.2618 21.6471L25.5274 27.6627C25.3766 27.78 25.191 27.8436 25 27.8436C24.809 27.8436 24.6234 27.78 24.4726 27.6627L16.7382 21.6471C16.6473 21.5785 16.571 21.4925 16.5136 21.3941C16.4563 21.2957 16.4191 21.1869 16.4041 21.0741C16.3892 20.9612 16.3968 20.8464 16.4266 20.7365C16.4564 20.6266 16.5077 20.5237 16.5776 20.4338C16.6475 20.3439 16.7346 20.2688 16.8338 20.2129C16.933 20.1569 17.0423 20.1212 17.1553 20.1079C17.2684 20.0945 17.383 20.1038 17.4925 20.1351C17.602 20.1665 17.7042 20.2192 17.7931 20.2904L25 25.8957L32.2069 20.2904C32.3871 20.1543 32.6137 20.0946 32.8376 20.1242C33.0614 20.1538 33.2647 20.2704 33.4033 20.4487C33.5419 20.627 33.6047 20.8526 33.5783 21.0769C33.5518 21.3012 33.4381 21.506 33.2618 21.6471Z" fill="currentColor"/>
            </svg>
          )}
        </div>
      </div>

      <div className="notification-content">
        <h3 className="notification-title">{title}</h3>
        <p className="notification-message">{message}</p>
        <span>{dateTime ? `${dateTime}` : dateTime}</span>
      </div>

      <div className="notification-time" onClick={askDelete} title="Delete">
        <svg width="30" height="30" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M34.7988 15.221L33.0904 18.1764L12.3683 6.21811L14.0767 3.2627L19.27 6.25228L21.5933 5.6202L28.9904 9.89103L29.6225 12.2314L34.7988 15.221ZM10.25 32.4581V11.9581H18.9113L30.75 18.7914V32.4581C30.75 33.3643 30.39 34.2333 29.7493 34.8741C29.1085 35.5148 28.2395 35.8748 27.3333 35.8748H13.6667C12.7605 35.8748 11.8915 35.5148 11.2507 34.8741C10.61 34.2333 10.25 33.3643 10.25 32.4581Z" fill="#BDBDBD"/>
        </svg>
      </div>
    </div>
  );
};

export default NotificationItem;
